import styled from 'styled-components';
import { PostBox } from '../home/Home.style';

export const JobCreateStyles = styled.div`
  height: auto;
  padding-bottom: 20px;
  ${PostBox} {
    padding: 8px 12px 20px 12px;
  }
  .custom-job-steps {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin: 10px 0;
  }

  .job-step-hr-line {
    height: 2px;
    width: 83%;
    position: absolute;
    background: linear-gradient(
      90deg,
      rgba(234, 173, 41, 1) 0%,
      rgba(183, 82, 21, 1) 48%,
      rgba(80, 230, 255, 1) 100%
    );
    bottom: 64%;
    left: 6%;
  }

  .job-step-hr-line.disable {
    background: #b8b8b8;
  }

  .job-step.disable {
    cursor: not-allowed;
    .job-publish-icon {
      background-color: ${({ theme }) =>
        theme.mode === 'light' ? '#f5f5f5' : theme.lightGray};
      border: 2px solid
        ${({ theme }) => (theme.mode === 'light' ? '#f5f5f5' : theme.lightGray)};
      svg path {
        fill: #b8b8b8;
      }
    }
    .job-publish-title {
      color: ${({ theme }) => theme.disableText1};
    }
  }

  .job-step {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    z-index: 1;
    .job-step-icon {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 6px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
    :hover .job-form-icon {
      box-shadow: 0px 0px 20px 0px rgba(234, 173, 41, 1);
    }

    :hover .job-publish-icon:not(.disable) {
      box-shadow: 0px 0px 20px 0px rgba(80, 230, 255, 1);
    }
    .job-form-icon {
      background-color: #eaad29;
      border: 1.5px solid #b75215;
    }
    .job-publish-icon {
      background-color: #50e6ff;
      border: 1.5px solid #085b69;
    }
    .job-form-title {
      color: ${({ theme }) => theme.text1};
    }
    .job-publish-title {
      color: #085b69;
    }
  }
`;

export const JobForm = styled.div`
  .field-wrap {
    display: flex;
    justify-content: space-between;
    > div {
      width: 49%;
    }
  }
  .field-wrap-btn {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    > div:first-child {
      width: 49%;
    }
    > div:nth-child(2) {
      width: 36.5%;
    }
    > button {
      margin-bottom: 2px;
    }
  }
  .field-employment {
    .MuiInputBase-root:not(.MuiInputBase-multiline) {
      height: auto !important;
    }
    .multiselect-container {
      flex-wrap: wrap;
    }
  }
  .job-chip-container {
    .MuiChip-filled {
      margin: 6px 4px 0 0;
    }
  }
  .job-form-title {
    color: ${({ theme }) => theme.text1};
    margin-top: 30px;
    margin-bottom: 0px;
  }
  .inputContainer,
  .selectContainer,
  .text-editor {
    margin-top: 15px;
  }
  .job-or {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 10px 0;
    > div {
      width: 200px;
      font-size: 14px;
    }
  }
  .job-select-btn {
    width: 100%;
  }
  .job-img-wrap {
    display: flex;
    justify-content: space-between;
    > div:nth-child(2) {
      width: 76.5%;
    }
    > div:nth-child(1) {
      width: 21%;
      margin-top: 15px;
    }
  }
  .job-preview-submit {
    margin-top: 30px;
    text-align: right;
  }
  .selected-template {
    margin-top: 6px;
  }
  .job-text-editor .ql-container {
    min-height: 250px;
  }
`;

export const JobPostsStyle = styled.div`
  ${PostBox} {
    height: calc(100vh - 135px);
    padding-bottom: 6px;
    margin-bottom: 10px;
    border-radius: 4px;
    @media only screen and (max-width: 599px) {
      height: auto;
    }
  }
  .image_con_po {
    img {
      width: 80px;
      height: 80px;
      border-radius: 4px;
      border: 1px solid #c4c4c4;
    }
  }
  .job-short-preview {
    position: relative;
    padding: 8px 0;
    color: ${({ theme }) => theme.text1};
    .job-updated-time {
      position: absolute;
      top: 50px;
      right: 0px;
      color: #828282;
      font-size: 14px;
    }
    h2 {
      margin: 3px 0 3px 0;
      font-size: 16px;
      // width: 87%;
      a:not(:hover) {
        color: ${({ theme }) => theme.colors[2]} !important;
        text-decoration: none;
      }
    }
    @media only screen and (max-width: 500px) {
      h2 {
        width: 80%;
      }
    }
    .MuiChip-sizeSmall {
      margin-right: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    svg {
      fill: #828282;
    }
    .job-types:last-child {
      margin-bottom: 0;
      position: relative;
      bottom: 4px;
    }
  }
  .job-company-logo,
  .job-sample-company-logo {
    width: 60px !important;
    height: 60px !important;
    border-radius: 4px;
    line,
    path {
      stroke: #828282;
    }
  }
  .job-brief-icon {
    margin-right: 6px !important;
  }
  .job-types {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    svg {
      margin-right: 4px;
      min-width: 22px;
      min-height: 22px;
      path {
        fill: #828282;
      }
    }
    .currency {
      font-size: 14px;
      margin-left: 2px;
    }
  }
  .job-work-location {
    align-items: flex-start;
    margin-bottom: 2px;
    svg {
      width: 25px;
    }
    > div {
      display: flex;
      flex-wrap: wrap;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      > div {
        margin-bottom: 6px;
      }
    }
  }

  .job-apply-button {
    margin: 8px 0 12px 0;
    display: flex;
    justify-content: end;
    width: 100%;
    svg path {
      fill: #ffffff;
    }
    .job-applied-error {
      border: none;
      font-size: 15px;
      padding: 4px 12px;
    }
    .job-applied {
      font-size: 15px;
      padding: 4px 12px;
    }
    button {
      box-shadow: none;
      padding: 4px 12px;
    }
  }
  .job-link-button {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .job-link-down-arrow {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    margin-left: 1px;
    padding: 0px !important;
    min-width: 30px;
    height: 33px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .comapny-details-container {
    display: flex;
    svg path {
      fill: #828282;
    }
  }
  .company-header {
    margin-left: 8px;
    color: ${({ theme }) => theme.text1};
    h3 {
      margin: 0 0 3px 0;
    }
    a {
      color: #1976d2;
      word-break: break-all;
    }
  }
  .company-title {
    font-weight: 600;
  }
  .company-size {
    font-size: 14px;
    margin-top: 4px;
  }
  .company-link {
    svg {
      width: 18px;
      height: 18px;
      fill: #1976d2;
      position: relative;
      top: 5px;
    }
  }
  .job-preview-image {
    display: flex;
    margin-bottom: 8px;
    .job-list-company-logo {
      width: 50px !important;
      height: 50px !important;
      border-radius: 2px;
      border: 1px solid ${({ theme }) => theme.border1};
      margin-top: 3px;
    }
    .job-list-sample-company-logo {
      max-width: 50px !important;
      max-height: 50px !important;
      line {
        stroke: #828282 !important;
      }
      path {
        fill: transparent;
        stroke: #828282 !important;
      }
    }
  }
  .job-preview-header {
    width: calc(86% - 50px);
    margin-left: 8px;
    h2 {
      margin: 0px;
    }
  }
  .comapny-short-preview {
    display: flex;
  }
  .job-publish-button {
    margin: 10px 0;
    text-align: right;
    button {
      margin-left: 8px;
    }
  }
  .pagination-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    height: 35px;
    padding-top: 4px;
    background-color: ${({ theme }) => theme.Bg1};
  }
  .job-no-data-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
    color: #c4c4c4;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    svg {
      width: 130px;
      height: 130px;
      margin-bottom: 10px;
    }
  }
  .sub-title {
    margin-top: 12px;
    margin-bottom: 6px;
    font-size: 17px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }
  .company-preview-container {
    padding-bottom: 20px;
  }
  .job-more-btn {
    position: absolute;
    top: 16px;
    right: 0px;
  }
`;

export const JobSearchContainer = styled.div`
  padding: 0px 8px 12px;
  .search-input-container {
    display: flex;
    .MuiInputBase-root {
      padding-left: 4px;
      input:not(.MuiAutocomplete-input) {
        padding-left: 2px !important;
      }
      svg {
        fill: #828282;
      }
    }
  }
  .search-title,
  .search-location {
    width: 30%;
    margin-right: 8px;
  }
  @media only screen and (max-width: 500px) {
    .search-title,
    .search-location {
      width: 40%;
    }
  }
  .search-btn {
    display: flex;
  }

  .job-filter-btn {
    margin-left: 6px;
    .MuiButton-startIcon {
      margin-left: 0px;
      margin-right: 0px;
    }
    button {
      padding: 0;
      min-width: 38px;
      height: 36.5px;
    }
    svg {
      fill: #1976d2;
      width: 20px;
      height: 20px;
    }
  }

  .job-alert {
    position: absolute;
    right: 8px;
    button {
      padding: 0;
      min-width: 38px;
      height: 36.5px;
    }
    svg {
      fill: #1976d2;
      width: 24px;
      height: 24px;
    }
  }
`;

export const JobFilterModal = styled.div`
  padding: 8px 16px;
  .job-filter-close-icon {
    position: absolute;
    top: 37px;
    right: 25px;
  } 
  .job-filter-title {
    margin: 25px 0px 12px 0;
    text-align: center;
    font-weight: 600;
    font-size: 22px;
    color: ${({ theme }) => theme.fieldText1};
  }
  .row-btn {
    display: grid;
    align-items: end;
    grid-template-columns: 49% 49%;
    column-gap: 2%;
    padding: 12px 0 12px 0;
  }
  .MuiFormControlLabel-root {
    margin: 12px 0px;
  }
  .MuiDialogActions-root {
    button {
      font-weight: 600;
    }
  }
`;

export const JobAlertModal = styled.div`
  .row-btn {
    display: grid;
    align-items: end;
    grid-template-columns: 49% 49%;
    column-gap: 2%;
    padding: 4px 0 4px 0;
  }
  @media only screen and (max-width: 600px) {
    .row-btn-grid {
      display: inherit;
    }
    .job-alert-footer {
      margin-top: 6px;
    }
  }
  // .MuiSelect-select {
  //   overflow-x: scroll !important;
  // }
  h4 {
    margin-top: 12px;
    margin-bottom: 4px;
  }
  hr {
    margin: 15px 0;
  }
  .label-block {
    display: inherit;
    > div:first-child {
      width: 150px;
      font-size: 14px;
      margin: 2px 0;
    }
    > div:nth-child(2) {
      font-size: 15px;
      font-weight: 600;
    }
  }
  ${PostBox} {
    // margin-top: 6px;
    padding: 8px 12px;
    position: relative;
    margin: 6px 2px 0;
  }
  .alert-action {
    position: absolute;
    right: 10px;
  }
  .job-alert-edit {
    svg path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .job-alert-footer {
    display: flex;
    justify-content: flex-end;
    button {
      margin-left: 8px;
    }
  }
`;

export const JobAlertPopover = styled.div`
  padding: 12px;
  width: 165px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  button {
    margin-top: 8px;
    font-size: 14px;
  }
`;

export const JobPostList = styled.div`
  display: flex;
  .job-list-container {
    position: relative;
    width: 35%;
    min-width: 300px;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.Bg1};
    > div:nth-child(1) {
      max-height: calc(100vh - 135px);
      overflow-y: auto;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    @media only screen and (max-width: 599px) {
      padding-bottom: 0px;
      > div:nth-child(1) {
        max-height: inherit;
      }
    }
  }
  .job-list-search-container {
    width: 100%;
  }
  > div:nth-child(3) {
    width: 65%;
    padding: 0 12px;
    height: calc(100vh - 135px);
    overflow-y: auto;
  }
  @media only screen and (max-width: 768px) {
    display: block;
    .job-list-container {
      width: 100%;
    }
    > div:nth-child(3) {
      width: calc(100% - 24px);
    }
  }
  .job-list-item {
    display: flex;
    padding: 8px 6px;
    // height: 80px;
    position: relative;
    &:hover {
      background-color: ${({ theme, isdisable }) =>
        isdisable ? 'transparent' : theme.fieldDisable1};
      cursor: ${({ theme, isdisable }) => (isdisable ? 'inherit' : 'pointer')};
      .job-title {
        text-decoration: underline;
      }
    }
    .job-list-short-preview {
      padding-left: 6px;
    }
    line,
    path {
      stroke: #828282;
    }
  }

  .job-list-selected-item {
    background-color: ${({ theme }) => theme.tabBg1};
    color: ${({ theme }) => theme.text1};
  }

  .job-list-company-logo,
  .job-list-sample-company-logo {
    width: 50px !important;
    height: 50px !important;
    border-radius: 2px;
    border: 1px solid ${({ theme }) => theme.border1};
  }
  .job-companyname {
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .job-list-short-preview {
    color: ${({ theme }) => theme.text1};
    width: calc(100% - 56px);
    position: relative;
    bottom: 2px;
    .job-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #1976d2;
      font-weight: 600;
    }
    svg path {
      fill: #828282;
    }
  }
  .job-list-types {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }
  .job-list-post-time {
    font-size: 14px;
    color: #828282;
    position: absolute;
    right: 0px;
    bottom: -7px;
  }
  .job-title, .job-list-types {
    max-width: clamp(150px, 70vw, 400px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ProfileJobList = styled.div`
  margin-top: 8px;
  .job-list-item {
    display: flex;
    padding: 8px 6px;
    // height: 80px;
    position: relative;
    .job-list-short-preview {
      padding-left: 6px;
      .job-title {
        font-weight: 600;
      }
    }
  }
  .job-list-company-logo,
  .job-list-sample-company-logo {
    width: 50px !important;
    height: 50px !important;
    border-radius: 2px;
    border: 1px solid ${({ theme }) => theme.border1};
    path,
    line {
      stroke: #828282;
    }
  }
  .job-companyname {
    font-size: 15px;
    width: fit-content;
  }
  .job-list-types {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }
  .job-title, .job-list-types {
    max-width: clamp(150px, 70vw, 400px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .job-list-post-time {
    font-size: 14px;
    color: #828282;
    position: absolute;
    right: 8px;
    bottom: 3px;
  }
  .more-outline {
    position: absolute;
    top: 10px;
    right: 0;
    padding: 3px;
    border-radius: 5px;
    cursor: pointer;
    button {
      svg {
        fill: ${({ theme }) => theme.svg1};
      }
    }
  }
  .profile-create-post {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const JobDetailView = styled.div`
  height: auto;
  padding-bottom: 100px;
  ${PostBox} {
    padding: 8px 24px;
  }
`;

export const JobPopoverContent = styled.div`
  font-size: 15px;
  // color: #333;
  > div {
    display: flex;
    padding: 12px 18px;
    align-items: center;
    width: 140px;
    cursor: pointer;
    &:hover {
      background-color: ${({ theme }) => theme.Bg1};
    }
    svg {
      width: 20px;
      height: 20px;
      margin-right: 12px;
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .user-job-view {
    path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .deletelist-icon {
    svg {
      fill: #fc223b;
    }
    color: #fc223b;
  }
  .job-edit-disable {
    cursor: default;
    color: #cacaca;
    svg {
      fill: #cacaca;
    }
  }
  .edit-count {
    padding-top: 6px;
  }
`;

export const ProfileJobAppliedStatus = styled.div`
  font-size: 15px;
  margin-top: 8px;
  .applied-status-title {
    font-size: 16px;
    font-weight: 600;
  }
  .applied-status-date {
    font-size: 13px;
    color: #828282;
    font-weight: 600;
  }
  .applied-status-container {
    display: flex;
    position: relative;
    > div:nth-child(2) {
      margin-left: 8px;
      a {
        color: #1976d2;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
      > div:not(:nth-child(1)) {
        margin-top: 2px;
      }
    }
    .view-applied {
      position: absolute;
      right: 4px;
      padding: 8px;
      path {
        fill: ${({ theme }) => theme.svg1};
      }
    }
  }
  .applied-status-company-logo {
    width: 60px !important;
    height: 60px !important;
    border-radius: 2px;
  }
  .status-title {
    font-size: 15px;
    font-weight: 500;
    margin-right: 8px;
  }
  .applied-status-chip-container {
    padding: 16px 0;
    display: flex;
    align-items: center;
    .MuiChip-root {
      height: 24px;
      font-size: 14px;
    }
  }
  .list-emoji {
    font-size: 22px;
    margin-left: 8px;
  }
`;

export const JobLinkPopover = styled.div`
  padding: 12px 16px;
  .job-link-item {
    display: flex;
    align-items: center;
  }
  .job-link-icon-item {
    margin-left: 8px;
    display: flex;
    svg {
      width: 20px;
      height: 20px;
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .job-link-path {
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .job-link-icon {
    cursor: pointer;
    &:hover {
      fill: #1976d2;
    }
  }
`;
